import L from 'leaflet'

// Fix for default marker icons in react-leaflet
export const initializeLeafletIcons = () => {
  delete L.Icon.Default.prototype._getIconUrl
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: '/images/markers/marker-icon-2x.png',
    iconUrl: '/images/markers/marker-icon.png',
    shadowUrl: '/images/markers/marker-shadow.png',
  })
}

// Helper to determine filter category for markers
export const getMarkerFilterCategory = (confirmationCount) => {
  if (confirmationCount === 0) return 'unconfirmed'
  if (confirmationCount === 1) return 'one'
  if (confirmationCount >= 2 && confirmationCount <= 3) return 'twoThree'
  if (confirmationCount >= 4) return 'fourPlus'
  return 'unconfirmed'
}

// Utility function to calculate the visible center of the map working area
// This accounts for the control container at the top, ensuring markers and popups
// appear in the visible area below the controls
export const getVisibleMapCenter = (map, isSearchPanelMinimized) => {
  if (!map) return null
  
  // Control container heights (approximate)
  const controlHeight = isSearchPanelMinimized ? 80 : 380
  const mapSize = map.getSize()
  
  // Calculate the center point of the visible map area (below control container)
  const visibleCenterY = controlHeight + ((mapSize.y - controlHeight) / 2)
  
  // Convert container point to lat/lng
  return map.containerPointToLatLng([
    mapSize.x / 2,
    visibleCenterY
  ])
}

// Helper function to offset overlapping markers in a circular pattern
export function applyMarkerOffsets(locations) {
  const coordMap = {} // Object to group locations by coordinate

  // Group locations by coordinate
  locations.forEach(loc => {
    const key = `${loc.currentLatitude},${loc.currentLongitude}`
    if (!coordMap[key]) {
      coordMap[key] = []
    }
    coordMap[key].push(loc)
  })

  // Apply offsets to locations that share coordinates
  const result = []
  Object.keys(coordMap).forEach(coordKey => {
    const locs = coordMap[coordKey]
    if (locs.length === 1) {
      // Single marker, no offset needed but create new object to ensure React detects changes
      result.push({ ...locs[0] })
    } else {
      // Multiple markers at same location - spread them in a circle
      const offsetDistance = 0.0002 // ~20 meters at this latitude
      locs.forEach((loc, index) => {
        const angle = (360 / locs.length) * index * (Math.PI / 180)
        const offsetLat = Math.cos(angle) * offsetDistance
        const offsetLng = Math.sin(angle) * offsetDistance

        result.push({
          ...loc,
          currentLatitude: loc.currentLatitude + offsetLat,
          currentLongitude: loc.currentLongitude + offsetLng
        })
      })
    }
  })

  return result
}

// Helper function to get a consistent color for an entity based on index
const TRAIL_COLORS = [
  '#3B82F6', // blue
  '#EF4444', // red
  '#10B981', // green
  '#F59E0B', // amber
  '#8B5CF6', // purple
  '#EC4899', // pink
  '#14B8A6', // teal
  '#F97316', // orange
  '#6366F1', // indigo
  '#84CC16', // lime
]

export function getEntityColor(index) {
  return TRAIL_COLORS[index % TRAIL_COLORS.length]
}
